<template>
  <div
    :id="id"
    class="element image draggable"
    :class="[
      cssClasses,
      animationInStyle,
      animationOutStyle,
      { selected: isSelected, locked: element.locked },
    ]"
    :style="basicStyles"
  >
    <transition
      :enter-active-class="'animated ' + animationIn"
      :leave-active-class="'animated ' + animationOut"
      :duration="{ leave: leaveDuration }"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
    >
      <div
        v-show="toggle"
        class="image-wrap"
        :class="[fillTypeClass, maskClass, loopingClass]"
        :style="[
          animationStyles,
          borderStyles,
          imageBorderRadiusStyles,
          boxShadowStyles,
          blurStyles,
          backgroundStyles,
        ]"
      >
        <template
          v-if="isVideoEmbed"
        >
          <video-embed
            class="media iframe"
            :network="currentPost.network"
            :src="src"
            :muted="mutePreview"
            :autoplay="element.videoOptions.autoplay"
            :loop="element.videoOptions.loop"
            @error="errorMessage"
          />
        </template>

        <template v-else-if="isVideo">
          <video
            :key="src"
            class="media video"
            type="video/mp4"
            :muted="mutePreview"
            :autoplay="element.videoOptions.autoplay"
            :loop="element.videoOptions.loop"
            :poster="poster"
            :src="src"
            @error="handleVideoError"
          />
        </template>

        <!-- TODO: figure out what to do for image load issues -->
        <img
          v-else
          :src="src"
          alt=" "
          class="media photo"
        >
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VideoEmbed from '../Embeds/VideoEmbed.vue';
import ElementsMixins from '../../mixins/elements-mixins';
import MoveMixins from '../../mixins/move-mixins';
import ResizeMixins from '../../mixins/resize-mixins';

const TIKTOK_BASE = process.env.TIKTOK_API;

export default {
  name: 'MultiMediaElement',
  components: {
    VideoEmbed,
  },
  mixins: [ElementsMixins, ResizeMixins, MoveMixins],
  props: {
    currentPost: {}, // for social only
    mutePreview: {
      default: true,
      required: true,
    },
  },
  computed: {
    ...mapGetters('graphicsTemplate', [
      'getElementById',
      'getDataValue',
    ]),
    element() {
      return this.getElementById(this.id);
    },
    isVideoEmbed() {
      return this.isVideo && (this.currentPost?.network === 'youtube' || this.currentPost?.network === 'facebook');
    },
    fillTypeClass() {
      return this.element.fillType ? this.element.fillType : '';
    },
    maskPosition() {
      return this.element.maskPosition ?? 'center-center';
    },
    maskClass() {
      return this.element.mask ? `mask ${this.element.maskShape} ${this.maskPosition}` : '';
    },
    imageBorderRadiusStyles() {
      return this.element.mask && this.element.maskShape === 'rectangle'
        ? {
          borderRadius: `${this.element.borderTopLeftRadius}px ${this.element.borderTopRightRadius}px ${this.element.borderBottomRightRadius}px ${this.element.borderBottomLeftRadius}px`,
        }
        : '';
    },

    src() {
      // todo: check image
      return this.getDataValue(this.element.id, 'src') || this.element.src;
    },
    isVideo() {
      return this.getDataValue(this.element.id, 'isVideo') || this.element.isVideo;
    },
    poster() {
      return this.getDataValue(this.element.id, 'poster') || (this.element.isVideo ? this.element.videoOptions.poster : '');
    },
  },
  methods: {
    errorMessage({ message }) {
      console.error(message);
    },
    async dealWithBadTiktokVideo() {
      const response = await fetch(
        `${TIKTOK_BASE}/video/${this.currentPost.post_id}`,
      );
      const src = await response.text();
      this.updateElementProp({
        id: this.id,
        propKey: 'src',
        propValue: src,
      });
    },
    handleVideoError(e) {
      if (this.element.network === 'tiktok' && this.isVideo) {
        this.dealWithBadTiktokVideo();
      } else {
        console.log('video error: ', e);
      }
    },
  },
};
</script>
